import { render, staticRenderFns } from "./ruleSettings.vue?vue&type=template&id=c712efc8&scoped=true"
import script from "./ruleSettings.vue?vue&type=script&lang=js"
export * from "./ruleSettings.vue?vue&type=script&lang=js"
import style0 from "./ruleSettings.vue?vue&type=style&index=0&id=c712efc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c712efc8",
  null
  
)

export default component.exports